import { Stack } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import error from '../../assets/images/error.png'

export default function Error() {
  const { t } = useTranslation()
  return (
    <Stack style={{ textAlign: 'center' }}>
      <img alt="error" src={error} style={{ margin: 'auto' }} width="200px" />
      <p style={{ fontWeight: 'bold', fontSize: '1rem' }}>
        {' '}
        {t('common.toast.errorEmail')}{' '}
        <a
          href="mailto:partners@cognentai.com"
          style={{
            color: 'var(--color-blue)',
          }}
        >
          partners@cognentai.com
        </a>
      </p>
    </Stack>
  )
}
